"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactSpring = require("react-spring");
var _reactUse = require("react-use");
var _scrollLock = require("../../packages/scroll-lock");
var _analytics = _interopRequireDefault(require("../analytics"));
var _CTAList = _interopRequireDefault(require("../CTAList"));
var _Text = _interopRequireDefault(require("../Text"));
var _index = _interopRequireWildcard(require("./index.styled"));
var _LinkItem = _interopRequireDefault(require("./LinkItem"));
var _jsxRuntime = require("react/jsx-runtime");
const MobileNavigation = function (_ref) {
  var _links$activeLink;
  let {
    subnavTitle,
    className,
    titleHref,
    titleTarget,
    titleAriaLabel,
    shortName,
    links,
    theme,
    mode = "default",
    ctas = [],
    activeLink,
    onClick,
    selectedUnderlineColor,
    scrollToSection,
    titleClick = function () {}
  } = _ref;
  const fireAnalytics = (0, _analytics.default)("PageNavigation");
  const [showDropdown, setDropdown] = (0, _react.useState)(false);
  const [isTransitioning, setIsTransitioning] = (0, _react.useState)(false);
  const containerRef = (0, _react.useRef)(null);
  const handleLinkClick = function (section, sectionId) {
    return function (evt) {
      onClick(section, sectionId)(evt);
      closeDropdown();
    };
  };
  const toggleDropdown = function (evt) {
    fireAnalytics("ExpandDropdown");
    if (!showDropdown) {
      scrollToSection(evt, false);
      if (containerRef.current) {
        containerRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
    setIsTransitioning(true);
    !isTransitioning && setDropdown(!showDropdown);
    setDropdown(!showDropdown);
  };
  const closeDropdown = function () {
    fireAnalytics("CollapseDropdown");
    setDropdown(false);
  };
  const onTitleClick = function () {
    titleClick();
    setDropdown(false);
  };
  (0, _reactUse.useMount)(function () {
    const globalNav = document.querySelector(".header-wrapper");
    const addGlobalNavListener = function () {
      if (globalNav !== null) {
        globalNav.addEventListener("click", closeDropdown);
      }
      return Boolean(globalNav);
    };
    if (!addGlobalNavListener()) {
      document.addEventListener("lexusGlobalNavLoaded ", addGlobalNavListener);
    }
    return function () {
      if (globalNav) {
        globalNav.removeEventListener("click", closeDropdown);
      }
      (0, _scrollLock.clearAllBodyScrollLocks)();
    };
  });
  (0, _react.useLayoutEffect)(function () {
    return showDropdown ? (0, _scrollLock.disableBodyScroll)(containerRef.current) : (0, _scrollLock.clearAllBodyScrollLocks)();
  }, [showDropdown]);
  const backdropTransition = (0, _reactSpring.useTransition)(showDropdown, null, {
    from: {
      opacity: "0",
      pointerEvents: "none"
    },
    enter: {
      opacity: "1",
      pointerEvents: "all"
    },
    leave: {
      opacity: "0",
      pointerEvents: "none"
    }
  });
  const AnimatedBackdrop = (0, _reactSpring.animated)(_index.default.Backdrop);
  const noTitle = !shortName && !subnavTitle;
  const hasCta = ctas.length > 0;
  const TypographyButton = _index.default.ButtonLink;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.ThemeProvider, {
    theme: {
      theme,
      mode,
      hasCta
    },
    "data-testid": "MobileNavigation",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.PageNavigation, {
      showDropdown: showDropdown,
      className: className,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Container, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Left, {
          noTitle: noTitle,
          children: noTitle ? null : !shortName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Model, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ModelButton, {
              href: titleHref,
              target: titleTarget,
              onClick: onTitleClick,
              ...(titleAriaLabel && {
                "aria-label": titleAriaLabel
              }),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: subnavTitle
              })
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Model, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ModelButton, {
              href: titleHref,
              target: titleTarget,
              onClick: onTitleClick,
              ...(titleAriaLabel && {
                "aria-label": titleAriaLabel
              }),
              children: shortName
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.Right, {
          onClick: toggleDropdown,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.SectionName, {
            tabIndex: "-1",
            children: ((_links$activeLink = links[activeLink]) === null || _links$activeLink === void 0 ? void 0 : _links$activeLink.text) || ""
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DropdownButton, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DropdownArrow, {
              isDropdownOpen: showDropdown
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DropDown, {
          isOpen: showDropdown,
          ref: containerRef,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Links, {
            children: links.map(function (link, id) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkItem.default, {
                active: activeLink === id,
                onClick: handleLinkClick(link.href, id),
                underlineColor: selectedUnderlineColor,
                "data-testid": "MobileNavigation",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TypographyButton, {
                  as: _index.default.Link,
                  id: `${id}Link`,
                  href: link.href,
                  target: link.target,
                  ...(link.ariaLabel && {
                    "aria-label": link.ariaLabel
                  }),
                  children: link.text
                })
              }, `${link.href}-${id}`);
            })
          }), hasCta && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.ButtonList, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Button, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CTAList.default, {
                size: "small",
                ctas: ctas
              })
            })
          })]
        })]
      }), backdropTransition.map(function (_ref2) {
        let {
          item,
          props,
          key
        } = _ref2;
        return item && /*#__PURE__*/(0, _jsxRuntime.jsx)(AnimatedBackdrop, {
          onClick: closeDropdown,
          style: props
        }, key);
      })]
    })
  });
};
var _default = exports.default = MobileNavigation;